


import {
  defineComponent,
  PropType,
  ref,
  watch,
  computed,
} from '@vue/composition-api';

import type {
  EmergencyResponseTeamCarExt,
} from '@/models/externalReports/emergencyResponseTeam/emergencyResponseTeamCar';
import { dtFormat } from '@/lib/dateHelper';
import { PaneStyle } from '@/models/externalReports/emergencyResponseTeam/emergencyResponseTeamMap';
import {
  PANE_SIDE_HARD_MAX_WIDTH_PX,
  LIST_HARD_MAX_HEIGHT_PX,
} from '@/components/ExternalReports/EmergencyResponseTeam/consts';
import useEmergencyResponseTeamCars from '@/components/ExternalReports/EmergencyResponseTeam/composables/useCars';
import type {
  ExternalReportSettings,
  ExternalReportsLabelPc,
} from '@/models/apis/externalReports/external_report_settings';

export default defineComponent({
  props: {
    userSettings: {
      type: Object as PropType<ExternalReportSettings>,
      required: true,
    },
    showCarIcons: {
      type: Boolean,
      default: true,
    },
    paneStyle: {
      type: Object as PropType<PaneStyle>,
      default: () => ({
        paneSideMinWidth: PANE_SIDE_HARD_MAX_WIDTH_PX,
        paneSideMaxWidth: PANE_SIDE_HARD_MAX_WIDTH_PX,
        listMinHeight: LIST_HARD_MAX_HEIGHT_PX,
        listMaxHeight: LIST_HARD_MAX_HEIGHT_PX,
      }),
    },
  },
  emits: ['click-car-on-car-list', 'change-show-car-icons'],
  setup(props, { emit }) {
    const { carState } = useEmergencyResponseTeamCars();
    const checkedShowCarIcons = ref(props.showCarIcons);
    const pcLabels = computed<ExternalReportsLabelPc>(() => (props.userSettings?.pc ?? {}) as ExternalReportsLabelPc);
    const visibleCars = computed<EmergencyResponseTeamCarExt[]>(() => carState.cars.filter(c => c.shouldShow));

    watch(() => props.showCarIcons, (value: boolean) => {
      checkedShowCarIcons.value = value;
    }, { immediate: true });

    const onClickCarOnCarList = (car: EmergencyResponseTeamCarExt) => {
      emit('click-car-on-car-list', car);
    };
    const onChangeShowCarIcons = () => {
      emit('change-show-car-icons');
    };
    return {
      // refs
      carState,
      checkedShowCarIcons,
      pcLabels,
      visibleCars,
      // methods
      onClickCarOnCarList,
      onChangeShowCarIcons,
      dtFormat,
    };
  },
});
